"use strict";

exports.__esModule = true;
exports.default = useUpdatedRef;

var _react = require("react");

/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 */
function useUpdatedRef(value) {
  var valueRef = (0, _react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}


//////////////////
// WEBPACK FOOTER
// ./~/@restart/hooks/cjs/useUpdatedRef.js
// module id = 943
// module chunks = 0